// Aurora Innovation, Inc. Proprietary and Confidential. Copyright 2026.
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { ratingClasses } from '@mui/material/Rating';
import { svgIconClasses } from '@mui/material/SvgIcon';
import { rem } from '../../tokens/conversions';
import { ratingColors } from './ratingColors';
export var Rating = function(mode) {
    var c = ratingColors(mode);
    var _obj, _obj1;
    var override = {
        MuiRating: {
            styleOverrides: {
                root: (_obj1 = {
                    gap: rem(0),
                    color: c.default.fill
                }, _define_property(_obj1, "& .".concat(ratingClasses.iconEmpty), {
                    color: c.default.border
                }), _define_property(_obj1, "&:hover", (_obj = {}, _define_property(_obj, "& .".concat(ratingClasses.iconFilled), {
                    color: c.hover.fill
                }), _define_property(_obj, "& .".concat(ratingClasses.iconEmpty), {
                    color: c.hover.border
                }), _obj)), _define_property(_obj1, "&.".concat(ratingClasses.disabled), _define_property({
                    opacity: 1,
                    color: c.default.border
                }, "& .".concat(ratingClasses.iconEmpty), {
                    color: c.default.border
                })), _obj1),
                sizeSmall: _define_property({}, "& .".concat(svgIconClasses.root), {
                    fontSize: rem(18)
                }),
                sizeMedium: _define_property({}, "& .".concat(svgIconClasses.root), {
                    fontSize: rem(24)
                }),
                sizeLarge: _define_property({}, "& .".concat(svgIconClasses.root), {
                    fontSize: rem(30)
                }),
                iconFilled: {
                    color: 'inherit'
                },
                iconEmpty: {
                    color: 'inherit'
                }
            },
            defaultProps: {
                size: 'medium'
            }
        }
    };
    return override;
};

//# sourceMappingURL=Rating.js.map